import React$1, { useState, useMemo, useEffect } from 'react';
import { d as _classCallCheck, e as _defineProperty, c as _asyncToGenerator, f as _typeof, g as _objectSpread2, b as _slicedToArray } from './_rollupPluginBabelHelpers-65a2e091.js';
import { decorate, observable } from 'mobx';
import { useNavigate } from 'react-router-dom';

var ModalStore = function ModalStore() {
  var _this = this;

  _classCallCheck(this, ModalStore);

  _defineProperty(this, "registerModal", function (modalObject) {
    _this.registeredModals.push(modalObject);
  });

  _defineProperty(this, "unregisterModal", function (modalId) {
    _this.registeredModals = _this.registeredModals.filter(function (modal) {
      return modal.id !== modalId;
    });
  });

  _defineProperty(this, "openModal", function (modal) {
    var matches = _this.registeredModals.filter(function (modalData) {
      return modalData.id === modal;
    });

    matches.forEach(function (match) {
      match.cb(true);

      _this.activeModals.push(match);

      _this.isModalOpen = true;
    });
  });

  _defineProperty(this, "closeModal", function (modal) {
    var matches = _this.registeredModals.filter(function (modalData) {
      return modalData.id === modal;
    });

    matches.forEach(function (match) {
      match.cb(false);
      _this.activeModals = _this.activeModals.filter(function (activeModal) {
        return activeModal.id !== modal;
      });
      _this.isModalOpen = _this.activeModals.length > 0;
    });
  });

  _defineProperty(this, "closeModalWithOverlay", function () {
    if (_this.activeModals.length > 0) {
      _this.activeModals.forEach(function (modal) {
        modal.cb(false);
      });

      _this.isModalOpen = false;
    }
  });

  this.activeModals = [];
  this.registeredModals = [];
};

decorate(ModalStore, {
  displayOverlay: observable,
  registeredModals: observable
});
var modalStore = new ModalStore();

var translate = function translate(id) {
  var replacements = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _config$locales = config.locales,
      locales = _config$locales === void 0 ? [] : _config$locales,
      stores = config.stores;
  var global = stores.global;
  var lang = global.lang;
  var keys = Object.keys(locales);
  var values = Object.values(locales);
  var messagesFromLang = keys.reduce(function (obj, key, index) {
    obj[key] = values[index][lang === null || lang === void 0 ? void 0 : lang.toLowerCase()];
    return obj;
  }, {});

  if (messagesFromLang[id === null || id === void 0 ? void 0 : id.toLowerCase()] !== undefined) {
    var _keys = Object.keys(replacements);

    var _values = Object.values(replacements);

    return _keys.reduce(function (translation, key, index) {
      var regex = new RegExp("{".concat(key, "}"), 'g');
      translation = translation.replace(regex, _values[index]);
      return translation;
    }, messagesFromLang[id === null || id === void 0 ? void 0 : id.toLowerCase()]);
  }

  if (config.enableI18nWarning) {
    console.warn("Missing translation key: ".concat(id === null || id === void 0 ? void 0 : id.toLowerCase()));
  }

  return id;
};
var Messages = function Messages() {
  _classCallCheck(this, Messages);
};

_defineProperty(Messages, "error", function (message, values) {
  var closetime = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2998;
  var toast = config.toast;
  toast.error(translate(message, values), {
    position: toast.POSITION.TOP_CENTER,
    autoClose: closetime
  });
});

_defineProperty(Messages, "success", function (message, values) {
  var closetime = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2000;
  var toast = config.toast;
  toast.success(translate(message, values), {
    position: toast.POSITION.TOP_CENTER,
    autoClose: closetime
  });
});

_defineProperty(Messages, "short", function (message, values) {
  var toast = config.toast;
  toast.success(translate(message, values), {
    position: toast.POSITION.TOP_CENTER,
    autoClose: 1000
  });
});

_defineProperty(Messages, "handleErrors", function (errors) {
  var Comp = function Comp() {
    return /*#__PURE__*/React$1.createElement("div", null, /*#__PURE__*/React$1.createElement("div", {
      className: "errorTitle",
      style: {
        marginBottom: '20px'
      }
    }, translate("resolve_the_following_errors")), /*#__PURE__*/React$1.createElement("ul", null, errors.map(function (error) {
      return /*#__PURE__*/React$1.createElement("li", {
        style: {
          marginBottom: '10px'
        },
        key: error.error
      }, "- ", error.error);
    })));
  };

  var toast = config.toast;
  toast.error( /*#__PURE__*/React$1.createElement(Comp, null), {
    position: toast.POSITION.TOP_CENTER,
    autoClose: 3000
  });
});

var doFetchText = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(url, method, body) {
    var options, statusCode, res, text;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            options = {
              method: method,
              credentials: "same-origin",
              headers: {
                Accept: "application/json, text/plain, */*",
                "Content-Type": "application/json"
              },
              body: JSON.stringify(body)
            };
            _context.next = 3;
            return fetch(url, options);

          case 3:
            res = _context.sent;
            statusCode = res.status;
            _context.next = 7;
            return res.text();

          case 7:
            text = _context.sent;

            if (!(statusCode !== 200)) {
              _context.next = 12;
              break;
            }

            throw text.message;

          case 12:
            return _context.abrupt("return", text);

          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function doFetchText(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
var doFetch = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(url, method, body) {
    var options, response;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            options = {
              method: method,
              credentials: "same-origin",
              mode: 'cors',
              headers: {
                Accept: "application/json, text/plain, */*",
                "Content-Type": "application/json"
              },
              body: JSON.stringify(body)
            };
            _context2.next = 3;
            return fetch(url, options);

          case 3:
            response = _context2.sent;

            if (!(response.status !== 200)) {
              _context2.next = 6;
              break;
            }

            throw new Error(response.message);

          case 6:
            _context2.next = 8;
            return response.json();

          case 8:
            return _context2.abrupt("return", _context2.sent);

          case 9:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function doFetch(_x4, _x5, _x6) {
    return _ref2.apply(this, arguments);
  };
}();
var doFetchV2 = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(url, method, body) {
    var options, response, textResponse, json;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            options = {
              method: method,
              credentials: "same-origin",
              headers: {
                Accept: 'application/json, text/plain, */*',
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(body)
            };
            _context3.next = 3;
            return fetch(url, options);

          case 3:
            response = _context3.sent;
            _context3.next = 6;
            return response.text();

          case 6:
            textResponse = _context3.sent;

            if (!(response.status === 429)) {
              _context3.next = 9;
              break;
            }

            throw new Error({
              status: 429,
              message: 'Too many requests'
            });

          case 9:
            _context3.prev = 9;
            json = JSON.parse(textResponse);
            return _context3.abrupt("return", {
              data: json,
              status: response.status
            });

          case 14:
            _context3.prev = 14;
            _context3.t0 = _context3["catch"](9);
            return _context3.abrupt("return", {
              data: textResponse,
              status: response.status
            });

          case 17:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[9, 14]]);
  }));

  return function doFetchV2(_x7, _x8, _x9) {
    return _ref3.apply(this, arguments);
  };
}();
var handleApiError = function handleApiError(err) {
  var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'an_error_has_occured';
  var values = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!Array.isArray(err)) {
    Messages.error(message, values);
  } else {
    console.log(err);
  }
};
var controlOnErrors = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(entity, validation) {
    var silent,
        keys,
        errors,
        _args5 = arguments;
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            silent = _args5.length > 2 && _args5[2] !== undefined ? _args5[2] : true;
            keys = Object.keys(validation !== undefined ? validation : entity.validation);
            errors = [];
            _context5.next = 5;
            return Promise.all(keys.map( /*#__PURE__*/function () {
              var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(key) {
                var valueToCheck, result;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                  while (1) {
                    switch (_context4.prev = _context4.next) {
                      case 0:
                        valueToCheck = key.includes('.') ? key.split('.').reduce(function (obj, child) {
                          return obj[child];
                        }, entity) : entity[key];

                        if (!(validation !== undefined)) {
                          _context4.next = 7;
                          break;
                        }

                        _context4.next = 4;
                        return validation[key](valueToCheck);

                      case 4:
                        _context4.t0 = _context4.sent;
                        _context4.next = 10;
                        break;

                      case 7:
                        _context4.next = 9;
                        return entity.validation[key](valueToCheck);

                      case 9:
                        _context4.t0 = _context4.sent;

                      case 10:
                        result = _context4.t0;
                        entity["error".concat(key.replace(/\./g, ''))] = result;

                        if (result.error) {
                          errors.push({
                            key: key,
                            error: result.message
                          });
                        }

                      case 13:
                      case "end":
                        return _context4.stop();
                    }
                  }
                }, _callee4);
              }));

              return function (_x12) {
                return _ref5.apply(this, arguments);
              };
            }()));

          case 5:
            return _context5.abrupt("return", new Promise(function (resolve, reject) {
              if (errors.length > 0) {
                if (!silent) {
                  Messages.handleErrors(errors);
                }

                reject(errors);
              } else {
                resolve(errors);
              }
            }));

          case 6:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function controlOnErrors(_x10, _x11) {
    return _ref4.apply(this, arguments);
  };
}();
var controlOnErrorsV2 = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(entity, validation) {
    var silent,
        validationFuncs,
        getValidationFuncs,
        errors,
        _args7 = arguments;
    return regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            silent = _args7.length > 2 && _args7[2] !== undefined ? _args7[2] : true;
            validationFuncs = [];

            getValidationFuncs = function getValidationFuncs(objectToValidate, validation) {
              var validationKeys = Object.keys(validation);
              validationKeys.forEach(function (key) {
                if (_typeof(validation[key]) === 'object') {
                  getValidationFuncs(objectToValidate[key], validation[key]);
                } else {
                  validationFuncs.push(new Promise( /*#__PURE__*/function () {
                    var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(resolve) {
                      var result;
                      return regeneratorRuntime.wrap(function _callee6$(_context6) {
                        while (1) {
                          switch (_context6.prev = _context6.next) {
                            case 0:
                              _context6.next = 2;
                              return validation[key](objectToValidate[key]);

                            case 2:
                              result = _context6.sent;
                              objectToValidate["error".concat(key)] = result;
                              resolve(result);

                            case 5:
                            case "end":
                              return _context6.stop();
                          }
                        }
                      }, _callee6);
                    }));

                    return function (_x15) {
                      return _ref7.apply(this, arguments);
                    };
                  }()));
                }
              });
            };

            getValidationFuncs(entity, validation !== undefined ? validation : entity.validation);
            _context7.next = 6;
            return Promise.all(validationFuncs);

          case 6:
            errors = _context7.sent;
            return _context7.abrupt("return", new Promise(function (resolve, reject) {
              if (errors.filter(function (errorObj) {
                return errorObj.error;
              }).length > 0) {
                if (!silent) {
                  Messages.handleErrors(errors);
                }

                reject(errors);
              } else {
                resolve(errors);
              }
            }));

          case 8:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));

  return function controlOnErrorsV2(_x13, _x14) {
    return _ref6.apply(this, arguments);
  };
}();
var openModal = function openModal(modalName) {
  var stores = config.stores;
  var modalStore = stores.modalStore;

  if (modalStore === undefined) {
    throw new Error('Modalstore missing from config');
  }

  modalStore.openModal(modalName);
};
var closeModal = function closeModal(modalName) {
  var stores = config.stores;
  var modalStore = stores.modalStore;

  if (modalStore === undefined) {
    throw new Error('Modalstore missing from config');
  }

  modalStore.closeModal(modalName);
};

var Global = function Global() {
  var _this = this;

  _classCallCheck(this, Global);

  _defineProperty(this, "toggleInfo", function () {
    _this.displayInfo = !_this.displayInfo;
  });

  _defineProperty(this, "loadStoredLanguage", function () {
    var languageToLoad = 'en';
    var possibleLanguages = ['es', 'en', 'fr', 'de', 'it', 'nl', 'dk', 'no'];
    var localStorageResult = localStorage.getItem('_site_lang');

    if (localStorageResult && possibleLanguages.includes(localStorageResult.toLocaleLowerCase())) {
      languageToLoad = localStorageResult.toLowerCase();
    }

    return languageToLoad;
  });

  _defineProperty(this, "updateLanguage", function (lang) {
    _this.lang = lang;

    if ((typeof Storage === "undefined" ? "undefined" : _typeof(Storage)) !== undefined) {
      localStorage.setItem('_site_lang', lang.toLowerCase());
    }
  });

  _defineProperty(this, "displayWarningModal", function (title, message, buttons) {
    _this.warningTitle = title;
    _this.warningMessage = message;
    _this.buttons = buttons;
    openModal('warningModal');
  });

  this.lang = this.loadStoredLanguage();
  this.warningMessage = '';
  this.warningTitle = '';
  this.buttons = [];

  if ((typeof Storage === "undefined" ? "undefined" : _typeof(Storage)) !== undefined) {
    localStorage.setItem('ws_enabled', this.wsEnabled);
  }
  this.languages = [{
    short: 'nl',
    long: 'Nederlands'
  }, {
    short: 'en',
    long: 'English'
  }, {
    short: 'es',
    long: 'Español'
  }, {
    short: 'it',
    long: 'Italiano'
  }, {
    short: 'dk',
    long: 'Dansk'
  }, {
    short: 'no',
    long: 'Norsk'
  }, {
    short: 'fr',
    long: 'Francais'
  }, {
    short: 'de',
    long: 'Deutsch'
  }];
};
decorate(Global, {
  lang: observable,
  buttons: observable,
  warningTitle: observable,
  warningMessage: observable
});
var global = new Global();

var stores = /*#__PURE__*/Object.freeze({
  __proto__: null,
  modalStore: modalStore,
  global: global
});

var Config = function Config() {
  var _this = this;

  _classCallCheck(this, Config);

  _defineProperty(this, "setLocales", function (locales) {
    _this.locales = locales;
  });

  _defineProperty(this, "setToast", function (toast) {
    _this.toast = toast;
  });

  _defineProperty(this, "setStores", function (stores) {
    var overwrite = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (overwrite) {
      _this.stores = stores;
    } else {
      _this.stores = _objectSpread2(_objectSpread2({}, _this.stores), stores);
    }
  });

  _defineProperty(this, "disableI18nWarnings", function () {
    _this.enableI18nWarning = false;
  });

  this.locales = [];
  this.stores = stores;
  this.enableI18nWarning = false;
  this.toast = undefined;
};

var config = new Config();

var useTranslation = function useTranslation(_ref) {
  var id = _ref.id,
      values = _ref.values;

  var _useState = useState(id),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var stores = config.stores,
      locales = config.locales;
  var global = stores.global;
  useMemo(function () {
    setValue(translate(id, values));
  }, [global.lang, id, locales, values]);
  return {
    value: value
  };
};
var useModal = function useModal() {
  var stores = config.stores;
  var modalStore = stores.modalStore;

  var register = function register(id, cb) {
    modalStore.registerModal({
      id: id,
      cb: cb
    });
  };

  var unregister = function unregister(id) {
    modalStore.unregisterModal(id);
  };

  return {
    register: register,
    unregister: unregister
  };
};
var useEscape = function useEscape(cb) {
  useEffect(function () {
    var execute = function execute(ev) {
      if (ev.keyCode === 27) {
        cb();
      }
    };

    document.addEventListener('keydown', execute);
    return function () {
      document.removeEventListener('keydown', execute);
    };
  }, []);
};
var useStores = function useStores() {
  var stores = config.stores;
  return stores;
};
var useWidthValidator = function useWidthValidator() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref2$minWidth = _ref2.minWidth,
      minWidth = _ref2$minWidth === void 0 ? 1024 : _ref2$minWidth;

  var width = window.innerWidth;

  var _useState3 = useState(width <= minWidth),
      _useState4 = _slicedToArray(_useState3, 2),
      isMobile = _useState4[0],
      setIsMobile = _useState4[1];

  var _useState5 = useState(width),
      _useState6 = _slicedToArray(_useState5, 2),
      windowWidth = _useState6[0],
      setWindowWidth = _useState6[1];

  useEffect(function () {
    var setWidth = function setWidth() {
      var width = window.innerWidth;
      setWindowWidth(width);

      if (width <= minWidth && !isMobile) {
        setIsMobile(true);
      } else if (width > minWidth && isMobile) {
        setIsMobile(false);
      }
    };

    window.addEventListener('resize', setWidth);
    return function () {
      window.removeEventListener('resize', setWidth);
    };
  }, [isMobile]);
  return {
    isMobile: isMobile,
    width: windowWidth
  };
};
var useRedirect = function useRedirect() {
  var navigate = useNavigate();

  var redirect = function redirect(location) {
    navigate(location);
  };

  return {
    redirect: redirect
  };
};
var useError = function useError(defaultState) {
  var _useState7 = useState(defaultState),
      _useState8 = _slicedToArray(_useState7, 2),
      error = _useState8[0],
      setError = _useState8[1];

  var _useState9 = useState([]),
      _useState10 = _slicedToArray(_useState9, 2),
      errors = _useState10[0],
      setErrors = _useState10[1];

  var clearError = function clearError() {
    if (error !== '') {
      setError('');
      setErrors([]);
    }
  };

  var setHtmlError = function setHtmlError(error) {
    if (!Array.isArray(error)) {
      console.log(error);
    }

    var writeErrors = function writeErrors() {
      var content = /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h2", {
        className: "errortitle"
      }, /*#__PURE__*/React.createElement(FormattedMessage, {
        id: "please_resolve_the_following_errors"
      })), /*#__PURE__*/React.createElement("ul", null, error.map(function (error, index) {
        return /*#__PURE__*/React.createElement("li", {
          key: index
        }, /*#__PURE__*/React.createElement(FormattedMessage, {
          id: error.error
        }));
      })));
      setErrors(error);
      setError(content);
    };

    var currentErrors = JSON.stringify(errors);
    var newErrors = JSON.stringify(error);

    if (currentErrors !== newErrors) {
      writeErrors();
    }
  };

  var setTranslatedError = function setTranslatedError(error) {
    setError(translate(error));
  };

  return {
    error: error,
    clearError: clearError,
    setError: setTranslatedError,
    setHtmlError: setHtmlError
  };
};
var useDebounce = function useDebounce(callback, deps) {
  var initial = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  var _useState11 = useState(''),
      _useState12 = _slicedToArray(_useState11, 2),
      result = _useState12[0],
      setResult = _useState12[1];

  var _useState13 = useState(JSON.stringify(deps)),
      _useState14 = _slicedToArray(_useState13, 2),
      value = _useState14[0],
      setValue = _useState14[1];

  var _useState15 = useState(null),
      _useState16 = _slicedToArray(_useState15, 2),
      timeout = _useState16[0],
      setTimeoutHandler = _useState16[1];

  var _useState17 = useState(Date.now()),
      _useState18 = _slicedToArray(_useState17, 2),
      lastTime = _useState18[0],
      setLastTime = _useState18[1];

  var _useState19 = useState(initial),
      _useState20 = _slicedToArray(_useState19, 2),
      initialExecute = _useState20[0],
      setInitialExecute = _useState20[1];

  var execute = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _result, newTimeout;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(lastTime + 1000 < Date.now())) {
                _context.next = 7;
                break;
              }

              _context.next = 3;
              return callback();

            case 3:
              _result = _context.sent;
              setResult(_result);
              _context.next = 10;
              break;

            case 7:
              if (timeout !== null) {
                clearTimeout(timeout);
              }

              newTimeout = setTimeout(execute, lastTime + 1000 - Date.now());
              setTimeoutHandler(newTimeout);

            case 10:
              setLastTime(Date.now());

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function execute() {
      return _ref3.apply(this, arguments);
    };
  }();

  useEffect(function () {
    if (initialExecute) {
      execute();
    } else {
      setInitialExecute(true);
    }
  }, [value]);
  useEffect(function () {
    setValue(JSON.stringify(deps));
  }, deps);
  return {
    result: result
  };
};

var FormattedMessage = function FormattedMessage(_ref) {
  var id = _ref.id,
      values = _ref.values;

  var _useTranslation = useTranslation({
    id: id,
    values: values
  }),
      value = _useTranslation.value;

  return /*#__PURE__*/React$1.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: value
    }
  });
};

export { FormattedMessage as F, Messages as M, useStores as a, useEscape as b, closeModal as c, useDebounce as d, doFetch as e, config as f, doFetchText as g, doFetchV2 as h, handleApiError as i, controlOnErrors as j, controlOnErrorsV2 as k, global as l, modalStore as m, useTranslation as n, openModal as o, useWidthValidator as p, useRedirect as q, useError as r, translate as t, useModal as u };
